/*******************************************************************************
//
//
//
//  #MENU
//
//
//
*******************************************************************************/

var Menu = (function() {
    var html = document.documentElement;
    var menu = document.querySelector('.c-menu');
    var trigger = document.querySelector('.js-menu-trigger');
    var focusedElementBeforeModal;
    var state;

    var _addEventListeners = function() {
        trigger.addEventListener('click', function(event) {
            event.preventDefault();

            toggle();
        });

        window.addEventListener('resize', function() {
            close();
        });
    };

    var close = function() {
        trigger.setAttribute('aria-expanded', false);
        menu.hidden = true;

        if(focusedElementBeforeModal) {
            focusedElementBeforeModal.focus();
        }

        html.classList.remove('is-menu-open');
        html.classList.remove('is-disable-scroll');
    };

    var open = function() {
        // Store current focused element
        focusedElementBeforeModal = document.activeElement;

        // Listen for keyboard
        menu.addEventListener('keydown', _addKeyboardListeners);

        // Find all focusable children
        var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
        var focusableElements = menu.querySelectorAll(focusableElementsString);

        focusableElements = Array.prototype.slice.call(focusableElements);

        var firstTabStop = focusableElements[0];
        var lastTabStop = focusableElements[focusableElements.length - 1];

        trigger.setAttribute('aria-expanded', true);
        menu.hidden = false;

        // Focus on first element in Modal
        firstTabStop.focus();

        html.classList.add('is-menu-open');
        html.classList.add('is-disable-scroll');

        function _addKeyboardListeners(event) {
            if (event.keyCode === 9) {
                if (event.shiftKey) {
                    if (document.activeElement === firstTabStop) {
                        event.preventDefault();
                        lastTabStop.focus();
                    }
                } else {
                    if (document.activeElement === lastTabStop) {
                        event.preventDefault();
                        firstTabStop.focus();
                    }
                }
            }

            if (event.keyCode === 27) {
                close();
            }
        }
    };

    var toggle = function() {
        state = JSON.parse(trigger.getAttribute('aria-expanded'));

        if(state === false) {
            open();
        } else {
            close();
        }
    };

    var init = function() {
        _addEventListeners();
    };

    return {
        init: init,
        close: close,
        open: open
    };
})();
